function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
var _templateObject, _templateObject2;
function _taggedTemplateLiteral(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
    raw: {
      value: Object.freeze(t)
    }
  }));
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
import "../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";
import { html as a } from "../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";
import "../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";
import { customElement as c } from "../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/decorators/custom-element.js";
import { NjcComboboxItem as m } from "./combobox-item.js";
import { unsafeHTML as d } from "../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/directives/unsafe-html.js";
import p from "../../../packages/web-components/src/components/combobox/combobox-item/combobox-item.slds.scss.js";
import { generateRandomId as b } from "../../../utils/string-utils.js";
import { unsafeCSS as u } from "../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/css-tag.js";
var h = Object.getOwnPropertyDescriptor,
  _ = function _(t, o, n, l) {
    for (var s = l > 1 ? void 0 : l ? h(o, n) : o, e = t.length - 1, i; e >= 0; e--) (i = t[e]) && (s = i(s) || s);
    return s;
  };
var r = /*#__PURE__*/function (_m) {
  function r() {
    var _this;
    _classCallCheck(this, r);
    _this = _callSuper(this, r, arguments), _this._randomId = b();
    return _this;
  }
  _inherits(r, _m);
  return _createClass(r, [{
    key: "createRenderRoot",
    value: function createRenderRoot() {
      return this;
    }
  }, {
    key: "render",
    value: function render() {
      return a(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n            <style>", "</style>\n            <li role=\"presentation\" class=\"slds-listbox__item\" @click=", " data-testid=\"nsc-combobox-option\">\n                <div id=\"", "\" class=\"slds-media slds-listbox__option slds-listbox__option_plain slds-media_small ", "\"  role=\"option\" tabindex=\"-1\">\n                    <span class=\"slds-media__figure slds-listbox__option-icon\">\n                        ", "\n                    </span>\n                    <span class=\"slds-media__body\">\n                        <span class=\"slds-truncate\" title=\"", "\">\n                            ", "\n                        </span>\n                    </span>\n                </div>\n            </li>\n        "])), u(p), this.selectOption, this._randomId, this.selectedValue == this.value ? "slds-is-selected" : "", this.selectedValue == this.value ? a(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["<span class=\"slds-icon_container slds-icon-utility-check slds-current-color\">\n                                  <nsc-icon name=\"check\" size=\"x-small\" svg-classes=\"slds-icon-text-default\"></nsc-icon>\n                                </span>"]))) : "", this.label, d(this.boldedSearchHtml));
    }
  }, {
    key: "boldedSearchHtml",
    get: function get() {
      return this.searchValue ? this.label.replace(new RegExp("(".concat(this.searchValue, ")"), "gi"), "<b>$1</b>") : this.label;
    }
  }]);
}(m);
r = _([c("nsc-combobox-item")], r);
export { r as NscComboboxItem };